/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface GetCommonState200ResponseDataMktuInner
 */
export interface GetCommonState200ResponseDataMktuInner {
  /**
   * Номер класса МКТУ
   * @type {number}
   * @memberof GetCommonState200ResponseDataMktuInner
   */
  classNumber: number
  /**
   * Количество фраз класса
   * @type {number}
   * @memberof GetCommonState200ResponseDataMktuInner
   */
  phraseCount: number
  /**
   * Количество фраз сверх лимита (платные)
   * @type {number}
   * @memberof GetCommonState200ResponseDataMktuInner
   */
  excessPhrasesCount: number
}

/**
 * Check if a given object implements the GetCommonState200ResponseDataMktuInner interface.
 */
export function instanceOfGetCommonState200ResponseDataMktuInner(
  value: object
): value is GetCommonState200ResponseDataMktuInner {
  if (!('classNumber' in value) || value['classNumber'] === undefined)
    return false
  if (!('phraseCount' in value) || value['phraseCount'] === undefined)
    return false
  if (
    !('excessPhrasesCount' in value) ||
    value['excessPhrasesCount'] === undefined
  )
    return false
  return true
}

export function GetCommonState200ResponseDataMktuInnerFromJSON(
  json: any
): GetCommonState200ResponseDataMktuInner {
  return GetCommonState200ResponseDataMktuInnerFromJSONTyped(json, false)
}

export function GetCommonState200ResponseDataMktuInnerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetCommonState200ResponseDataMktuInner {
  if (json == null) {
    return json
  }
  return {
    classNumber: json['classNumber'],
    phraseCount: json['phraseCount'],
    excessPhrasesCount: json['excessPhrasesCount'],
  }
}

export function GetCommonState200ResponseDataMktuInnerToJSON(
  value?: GetCommonState200ResponseDataMktuInner | null
): any {
  if (value == null) {
    return value
  }
  return {
    classNumber: value['classNumber'],
    phraseCount: value['phraseCount'],
    excessPhrasesCount: value['excessPhrasesCount'],
  }
}
